import { Button } from "antd"
import { RedoOutlined } from "@ant-design/icons"

const RefreshAppointments = (props) => {
    const { onRefresh } = props;
    return (
        <Button
            style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                position: "fixed",
                bottom: "140px",
                right: "20px",
                background: "white",
                zIndex: 100,
            }}
            icon={<span style={{ fontSize: "24px" }}> <RedoOutlined /></span>}
            type="secondary"
            onClick={onRefresh}
        />
    )
}

export default RefreshAppointments